module.exports = __webpack_public_path__ + "img/yaoqing_haibao.5ed6431e.png";